const ROLE_TYPES = Object.freeze({
    OPERATOR: 'operator',
    CONCIERGE: 'concierge',
    OTHER: 'other',
    ADMIN: 'admin',
    SUPER_ADMIN: 'super_admin',
    CONCIERGE_NIGTH: 'concierge_nigth',
    OPERATOR_VIP_CITY: 'operator_vip_city',
    BUSINESS_ADMIN: 'business_admin'
});

function isAuthorized(roles) {
    const settings = JSON.parse(localStorage.getItem('settings'));
    const userRole = settings ? settings.role : null;
    return roles.includes(userRole);
}

module.exports = {
    ROLE_TYPES,
    isAuthorized
};
